module.exports = __webpack_public_path__ + "img/b2-1.01c95fe.png";